import { AccountApiNS as NS } from "~types/api/account";

import { Box } from "@mui/material";

import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationCity from "@mui/icons-material/LocationCity";
import CookachuLogo from "~public/images/logo-sign.svg";

export default function Footer(props: {
  splashPage: NS.GetSplashPageInfoResponse;
}) {
  return (
    <Box
      style={{ color: props.splashPage.footer_text_color ?? "#FFFFFF" }}
      component={"footer"}
      sx={{
        backgroundColor: props.splashPage.footer_color
      }}>
      <div className="flex flex-col md:flex-row px-4 md:px-12 py-6 md:py-8 gap-6">
        {props.splashPage.show_footer_company && (
          <div className="flex flex-col gap-2 grow w-full md:w-1/3">
            <h2 className="text-xl font-bold">Company</h2>
            {props.splashPage.footer_company_text && (
              <div>{props.splashPage.footer_company_text}</div>
            )}
            {props.splashPage.footer_company_email && (
              <div>
                <EmailIcon className="mr-1" />
                {props.splashPage.footer_company_email}
              </div>
            )}
            {props.splashPage.footer_company_phone && (
              <div>
                <LocalPhoneIcon className="mr-1" />
                {props.splashPage.footer_company_phone}
              </div>
            )}
            {props.splashPage.footer_company_address && (
              <div>
                <LocationCity className="mr-1" />
                {props.splashPage.footer_company_address}
              </div>
            )}
          </div>
        )}
        {props.splashPage.show_footer_links && (
          <Box
            className="flex-col gap-2 grow w-full md:w-1/3"
            sx={{
              display: {
                xs: props.splashPage.footer_link_items?.length
                  ? "flex"
                  : "none",
                md: "flex"
              }
            }}>
            <h2
              className="text-xl font-bold"
              style={{
                opacity: props.splashPage.footer_link_items?.length ? 1 : 0
              }}>
              Quick Links
            </h2>
            {props.splashPage.footer_link_items?.map((item, index) => (
              <a
                key={index}
                href={item.url}
                target={item.open_tab ? "_blank" : "_self"}>
                {item.label}
              </a>
            ))}
          </Box>
        )}
        <div className="flex flex-col gap-2 grow w-full md:w-1/3">
          {props.splashPage.show_footer_poweredby_text && (
            <h2 className="text-xl font-bold">
              {props.splashPage.footer_poweredby_text ?? "Powered By"}
            </h2>
          )}
          {props.splashPage.show_footer_poweredby &&
            props.splashPage.footer_img && (
              <>
                {props.splashPage.footer_img ? (
                  <img
                    src={props.splashPage.footer_img}
                    style={{
                      objectFit: "contain",
                      width: "210px",
                      height: "auto"
                    }}
                    alt="logo"
                  />
                ) : (
                  <>
                    {/* <CookachuLogo
                    style={{
                      height: 41,
                      width: 210
                    }}
                  /> */}
                  </>
                )}
              </>
            )}
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-4 md:items-center pb-4 pt-5 border-t border-gray-300 px-4 md:px-12">
        <div className="grow">
          © {new Date().getFullYear()} {props.splashPage.company}. All rights
          reserved.
        </div>
        <div className="grow flex flex-col md:flex-row justify-end gap-4 md:gap-8">
          {props.splashPage.footer_privacy_policy && (
            <a href={props.splashPage.footer_privacy_policy}>Privacy Policy</a>
          )}
          {props.splashPage.footer_terms_of_service && (
            <a href={props.splashPage.footer_terms_of_service}>
              Terms of Service
            </a>
          )}
          {props.splashPage.footer_cookies_policy && (
            <a href={props.splashPage.footer_cookies_policy}>Cookie Policy</a>
          )}
          {props.splashPage.footer_sitemap && (
            <a href={props.splashPage.footer_sitemap}>Sitemap</a>
          )}
        </div>
      </div>
    </Box>
  );
}
